// Aviso flotante cuando llega un push con la app ABIERTA (app nativa).
// Android no muestra la notificación del sistema en primer plano; sin esto,
// el usuario "no ve" los push que sí llegaron. Tap → navega; se oculta solo.
import { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'

interface ToastData {
  title?: string
  body?: string
  url?: string
}

export function PushToast() {
  const [toast, setToast] = useState<ToastData | null>(null)
  const timer = useRef<ReturnType<typeof setTimeout>>()
  const navigate = useNavigate()

  useEffect(() => {
    const onPush = (e: Event) => {
      const d = (e as CustomEvent<ToastData>).detail
      if (!d?.title && !d?.body) return // evento sin datos (refresco de campana)
      setToast(d)
      clearTimeout(timer.current)
      timer.current = setTimeout(() => setToast(null), 7000)
    }
    window.addEventListener('ds-notification', onPush)
    return () => {
      window.removeEventListener('ds-notification', onPush)
      clearTimeout(timer.current)
    }
  }, [])

  if (!toast) return null
  return (
    <button
      onClick={() => {
        setToast(null)
        if (toast.url) navigate(toast.url)
      }}
      className="fixed inset-x-3 top-[calc(env(safe-area-inset-top)+0.75rem)] z-50 flex animate-fade-in items-start gap-3 rounded-2xl border border-ds-200 bg-white p-3 text-left shadow-cardhover sm:left-auto sm:right-4 sm:w-96"
    >
      <span className="grid h-9 w-9 shrink-0 place-items-center rounded-full bg-ds-50 text-lg">🔔</span>
      <span className="min-w-0 flex-1">
        <span className="block text-sm font-semibold text-gray-900">{toast.title ?? 'Hotel Depot Reparto'}</span>
        {toast.body && <span className="block truncate text-xs text-gray-600">{toast.body}</span>}
        {toast.url && <span className="mt-0.5 block text-[11px] font-medium text-ds-600">Toca para abrir</span>}
      </span>
    </button>
  )
}
